module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-m",
      "footer": true
    },
    on: {
      "closemodal": _vm.close,
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Send a test email")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-12 pt-3"
  }, [_c('label', {
    staticClass: "mb-1"
  }, [_vm._v("Send a test to:")]), _vm._v(" "), _c('div', {
    staticClass: "input-min-height mb-2"
  }, [_c('div', {
    staticClass: "col-sm-8 p-0",
    class: {
      error: _vm.$v.sendTo.$error
    }
  }, [_c('label', {
    staticClass: "full",
    class: {
      error: _vm.$v.sendTo.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTo),
      expression: "sendTo"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com"
    },
    domProps: {
      "value": (_vm.sendTo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.sendTo = $event.target.value
      }, _vm.$v.sendTo.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.sendTo.$invalid) ? _c('div', {
    staticClass: "messages error"
  }, [(!_vm.$v.sendTo.isEmailValid && _vm.$v.sendTo.required) ? _c('span', [_vm._v("Invalid email")]) : _vm._e(), _vm._v(" "), (!_vm.$v.sendTo.required) ? _c('span', [_vm._v("Email is required")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Select email test type:")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 ml-4 fs-small"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "darkest",
    attrs: {
      "value": "PreEvent"
    },
    model: {
      value: (_vm.emailType),
      callback: function($$v) {
        _vm.emailType = $$v
      },
      expression: "emailType"
    }
  }, [_vm._v("Reminder email")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('radio', {
    staticClass: "darkest",
    attrs: {
      "value": "PostEvent"
    },
    model: {
      value: (_vm.emailType),
      callback: function($$v) {
        _vm.emailType = $$v
      },
      expression: "emailType"
    }
  }, [_vm._v("Follow-Up Email")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn wider mr-3",
    class: {
      'tertiary': _vm.sendingEmail
    },
    attrs: {
      "type": "button",
      "disabled": _vm.$v.sendTo.$invalid
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [(!_vm.sendingEmail) ? _c('span', [_vm._v("Send Email")]) : _c('loader')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5d18f649", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d18f649"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/SendTestEmail.vue
// module id = 2259
// module chunks = 0